module.exports = __webpack_public_path__ + "img/button_ready.bae2e6c9.png";